import React from 'react';
import Sparkles, { SparklesTrend } from '../sparkles/Sparkles';
import './StatTile.scss';

interface StatTileProps {
  title: string;
  value: React.ReactNode;
  /** `ico--*` class drawn as the sparkles watermark. */
  icon: string;
  trend?: SparklesTrend;
  /** Rendered next to the value (e.g. change tags). */
  children?: React.ReactNode;
  /** Small line under the value (a hint, a progress bar). */
  footer?: React.ReactNode;
}

/** Admin stat tile: title, big value, the icon as a light sparkles watermark in the corner. */
const StatTile: React.FC<StatTileProps> = ({
  title,
  value,
  icon,
  trend = 'neutral',
  children,
  footer,
}) => (
  <div className="stat-tile">
    <Sparkles icon={icon} trend={trend} />
    <div className="stat-tile__title">{title}</div>
    <div className="stat-tile__value">
      {value}
      {children}
    </div>
    {footer && <div className="stat-tile__footer">{footer}</div>}
  </div>
);

export default StatTile;
